import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import {listSettingss} from "../graphql/queries";
import API, {GRAPHQL_AUTH_MODE} from "@aws-amplify/api";

export const getPageSettings = createAsyncThunk(
  'pageSettings/getPageSettings',
  async (arg, thunkAPI) => {
    const state = thunkAPI.getState();
    if (state.cognito.currentSession){
      return await API.graphql({query: listSettingss, authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS});
    }
    return await API.graphql({query: listSettingss, authMode: GRAPHQL_AUTH_MODE.AWS_IAM});
  }
);

export const defaultState = {
  NaskladneniDo: 5,
};

const nonRelevantSettings = ['CisloObjednavky'];

const pageSettingsSlice = createSlice({
  name: 'pageSettings',
  initialState: defaultState,
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
  },
  extraReducers: {
    [getPageSettings.rejected]: (state, action) => {
      Object.keys(defaultState).forEach(key => {
        state[key] = defaultState[key];
      });
    },
    [getPageSettings.fulfilled]: (state, action) => {
      const settings = action.payload?.data?.listSettingss?.items;
      if (!settings) {
        Object.keys(defaultState).forEach(key => {
          state[key] = defaultState[key];
        });
      }
      settings.forEach(setting => {
        if (nonRelevantSettings.indexOf(setting.name) !== -1) {
          return;
        }
        state[setting.name] = setting.value;
      });
    },
  },
});

export default pageSettingsSlice;
